import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlService } from 'app/core/http/url.service';
import { Observable } from 'rxjs';
import { ExploreActivitiesClassModel } from 'app/shared/models/explore-activities-class.model';
import { LoginTokenModelWithClass } from 'app/shared/models/login-token-model-with-class';
import { ExploreActivitiesUserDateModel } from 'app/shared/models/explore-activities-user-date.model';

@Injectable({
  providedIn: 'root'
})
export class ExploreActivitiesDataService {
  public constructor(private readonly httpClient: HttpClient,
                     private readonly urlService: UrlService) { }

  public getUserData(): Observable<ExploreActivitiesUserDateModel> {
    const url = this.urlService.buildServerApiUrl('Teacher/ExploreActivities');

    return this.httpClient.get<ExploreActivitiesUserDateModel>(url);
  }

  public createExploreActivitiesClass(activityModel: ExploreActivitiesClassModel): Observable<LoginTokenModelWithClass> {
    const url = this.urlService.buildServerApiUrl('Teacher/ExploreActivities');

    return this.httpClient.post<LoginTokenModelWithClass>(url, activityModel);
  }
}
